import { createSlice } from '@reduxjs/toolkit';

// ----------------------------------------------------------------------

const initialState = {
  progress: {},
  settings: {
    areToursHidden: false,
    isLoaded: false,
  },
  isLoading: false,
  currentTour: null,
  isRunning: false,
  lastFetchedAt: null,
  error: null,
  resetCounter: 0,
};

const slice = createSlice({
  name: 'tour',
  initialState,
  reducers: {
    setLoading(state, action) {
      state.isLoading = action.payload;
    },
    setProgress(state, action) {
      state.progress =
        action.payload &&
        typeof action.payload === 'object' &&
        !Array.isArray(action.payload)
          ? action.payload
          : {};
      state.lastFetchedAt = Date.now();
      state.isLoading = false;
      state.error = null;
    },
    setTourSettings(state, action) {
      state.settings = {
        areToursHidden: Boolean(action.payload?.areToursHidden),
        isLoaded: Boolean(action.payload?.isLoaded),
      };
    },
    updateTourProgress(state, action) {
      const { tourKey, ...progressData } = action.payload;
      state.progress[tourKey] = {
        ...state.progress[tourKey],
        ...progressData,
      };
    },
    removeTourProgress(state, action) {
      const tourKey = action.payload;
      delete state.progress[tourKey];
    },
    clearAllProgress(state) {
      state.progress = {};
      state.resetCounter += 1;
    },
    setCurrentTour(state, action) {
      state.currentTour = action.payload;
    },
    setRunning(state, action) {
      state.isRunning = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
      state.isLoading = false;
    },
    resetState() {
      return initialState;
    },
  },
});

export default slice.reducer;
export const {
  setLoading,
  setProgress,
  setTourSettings,
  updateTourProgress,
  removeTourProgress,
  clearAllProgress,
  setCurrentTour,
  setRunning,
  setError,
  resetState,
} = slice.actions;
